export class ListPolIntValidTokenSusPeticion {
        public codCliente: string;
}